import { Highlightable } from '@angular/cdk/a11y';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'gax-option',
  templateUrl: './option.component.html',
  styleUrls: ['./option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OptionComponent<T> implements Highlightable {
  @Input()
  value: T | null = null;

  @Input()
  @HostBinding('class.disabled')
  disabled = false;

  @Input()
  public multipleSelect: boolean = false;

  @HostBinding('class.selected')
  protected isSelected: boolean = false;

  @HostBinding('class.active')
  protected isActive: boolean = false;

  @Output()
  selected: EventEmitter<OptionComponent<T>> = new EventEmitter();

  @HostListener('click')
  protected select() {
    if (!this.disabled) {
      this.isSelected = true;
      this.selected.emit(this);
    }
  }

  constructor(
    private cd: ChangeDetectorRef,
    private el: ElementRef<HTMLElement>,
  ) {}

  setActiveStyles(): void {
    this.isActive = true;
    this.cd.markForCheck();
  }

  setInactiveStyles(): void {
    this.isActive = false;
    this.cd.markForCheck();
  }

  getLabel?(): string {
    return '';
  }

  scrollIntoView(scrollOptions: ScrollIntoViewOptions) {
    this.el.nativeElement.scrollIntoView(scrollOptions);
  }

  highlightAsSelected() {
    this.isSelected = true;
    this.cd.markForCheck();
  }

  addMultipleSelect() {
    this.multipleSelect = true;
    this.cd.markForCheck();
    this.cd.detectChanges();
  }

  deselect() {
    this.isSelected = false;
    this.cd.markForCheck();
  }
}
